import React from "react";
import { useNavigate } from "react-router-dom";
import { Store } from "components/Ui";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const CampaignBtn = ({onlyBack = false}) => {
  const {
    state: {
      activeFarm,
    }
  } = React.useContext(Store);
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };
  return (
    <Box className="p-8 bg-white mb-3 mt-3">
      <div className="flex space-x-12">
        <button
          className="accueil"
          onClick={() => handleNavigate("/campaigns")}
        >
          <ArrowBack />
          Campagnes
        </button>
        {!onlyBack && <div className="">
          <Typography color="secondary.main" fontWeight={600} fontSize={14}>
            Nom de l'Champs
          </Typography>
          <Typography fontWeight={600}>{activeFarm ? activeFarm.farmName : null}</Typography>
        </div>}
      </div>
    </Box>

  );
};
export default CampaignBtn;
